import React from "react";
import DatePicker from "react-datepicker";

import { inputBoxStyles } from "components/InputBox/input.style";

import "react-datepicker/dist/react-datepicker.css";

const DupontDatePicker = ({ label, labelClass, className, ...props }) => {
  const classes = inputBoxStyles(this);

  const handleRawChange = event => {
    const inputText = event.target.value;
    if (inputText) {
      const sanitizedText = inputText.replace(/[^\w\s:]/gi, ""); // Only allow alphabests numbers and colon
      event.target.value = sanitizedText;
    }
  };

  return (
    <div>
      <div className={labelClass}>{label}</div>
      <DatePicker
        {...props}
        className={`${classes.textfield} custom-input ${className}`}
        popperClassName="marginTop10"
        onChangeRaw={handleRawChange}
      />
    </div>
  );
};
export default DupontDatePicker;
